import { throttle } from 'lodash'

import postcss from 'postcss'

// https://www.npmjs.com/package/postcss-clean
// import clean from 'postcss-clean'
import clean from './postcss/postcss-clean'
import removeDuplicateProperties from './postcss/postcss-remove-duplicate-properties'
import getHash from 'Functions/get-hash'
/* ---------------------------------------------------- */
/* Update save button                                   */
/* ---------------------------------------------------- */
window.stlst_legacy.option_change = function() {
	return onOptionChange()
}

const callDebouncedOnOptionChange = throttle( debouncedOnOptionChange, 200 )

export default function onOptionChange() {
	callDebouncedOnOptionChange()
}

function debouncedOnOptionChange() {
	console.log( "debouncedOnOptionChange: !!!!!!!!!!!!!!!!!!!!!!!!!!!" );
	let editorCSS = window.Stylist.codeEditor.getValue()
	// Convert per-property <style>s into CSS string.
	const newCssData = window.stlst_legacy.get_clean_css( true )

	// Merge existing css data with new update value.
	// After this step have we will have duplicate css declaration.
	editorCSS = editorCSS + newCssData

	const newCssHash = getHash( editorCSS )
	const currentCssHash = window.Stylist.getCurrentCssHash()

	// Continue only if CSS code really changed...
	if ( newCssHash === currentCssHash ) {
		// CSS code didn't change.
		return
	}

	// CSS code changed.
	postcss( [
		clean( {
			level: {
				1: {
					all: true
				},
				2: {
					// all: false,
					mergeAdjacentRules: false, // Don't turn it on!
					// As it merges diferent selectors that has the same rules.
					mergeNonAdjacentRules: 'selector',
					restructureRules: true

					/*
					DEFAULT SETTINGS:
					mergeNonAdjacent: true,
					mergeIntoShorthands: true, // controls merging properties into shorthands; defaults to true
					mergeNonAdjacentRules: true, // controls non-adjacent rule merging; defaults to true
					mergeSemantically: false, // controls semantic merging; defaults to false

					overrideProperties: true, // controls property overriding based on understandability; defaults to true
					removeEmpty: true, // controls removing empty rules and nested blocks; defaults to `true`
					reduceNonAdjacentRules: true, // controls non-adjacent rule reducing; defaults to true
					removeDuplicateFontRules: true, // controls duplicate `@font-face` removing; defaults to true
					removeDuplicateMediaBlocks: true, // controls duplicate `@media` removing; defaults to true

					removeDuplicateRules: true, // controls duplicate rules removing; defaults to true
					removeUnusedAtRules: false, // controls unused at rule removing; defaults to false (available since 4.1.0)
					restructureRules: false, // controls rule restructuring; defaults to false
					*/
				}
			}, // https://github.com/jakubpawlowicz/clean-css#level-2-optimizations
			// these applied as well: https://github.com/jakubpawlowicz/clean-css#level-1-optimizations
			format: {
				semicolonAfterLastProperty: true,
				// 'beautify', // formats output in a really nice way
				breaks: { // controls where to insert breaks
					afterAtRule: true, // controls if a line break comes after an at-rule; e.g. `@charset`; defaults to `false`
					afterBlockBegins: true, // controls if a line break comes after a block begins; e.g. `@media`; defaults to `false`
					afterBlockEnds: true, // controls if a line break comes after a block ends, defaults to `false`
					afterComment: true, // controls if a line break comes after a comment; defaults to `false`
					afterProperty: true, // controls if a line break comes after a property; defaults to `false`
					afterRuleBegins: true, // controls if a line break comes after a rule begins; defaults to `false`
					afterRuleEnds: true, // controls if a line break comes after a rule ends; defaults to `false`
					beforeBlockEnds: true, // controls if a line break comes before a block ends; defaults to `false`
					betweenSelectors: true // controls if a line break comes between selectors; defaults to `false`
				},
				indentBy: 1,
				indentWith: 'tab',
				spaces: { // controls where to insert spaces
					aroundSelectorRelation: true, // controls if spaces come around selector relations; e.g. `div > a`; defaults to `false`
					beforeBlockBegins: true, // controls if a space comes before a block begins; e.g. `.block {`; defaults to `false`
					beforeValue: true // controls if a space comes before a value; e.g. `width: 1rem`; defaults to `false`
				},
			}
		} ),
		removeDuplicateProperties()
	] ).process( editorCSS ).then( result => {
		const optimizedCss = result.css

		// Cache new CSS code hash signature in the store.
		window.Stylist.setCurrentCssHash( getHash( optimizedCss ) )

		// Update css editor with optimized version of CSS.
		window.Stylist.codeEditor.setValue( optimizedCss )
		// ↑ Triggers onCodeEditorChange()

		// Update breakpoints if we are in the responsive mode currently.
		if ( window.stlst_legacy.is_responsive_mod() ) {
			window.stlst_legacy.updateResponsiveBreakpoints();
		}
	} )
}



// WEBPACK FOOTER //
// ./dev/stylist_parent/functions/on-option-change.js